import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { TemplateApiService } from '../services/template-api.service';
import { BuilderScreenBetaService } from '../services/builder-screen.service';
import { TabControlService } from '../services/tab-control.service';
import { SaveComponentsService } from '../services/save-components.service';
import { DataBindingService } from '../services/data-binding.service';
import { DataSyncService } from '../services/data-sync.service';
import { FormSyncService } from '../services/form-sync.service';
import { DataPathService } from '../services/data-path.service';
import { RxTimingService } from '../services/rx-timing.service';
import { FlowCompletionNotifyService } from '../services/flow-completion-notify.service';
import { Subscription } from 'rxjs';

export interface TemplateDetailContext {
  evento?: string;
  row?: any;
  formGroup?: any;
  parentRow?: any;
  entityName?: string;
  tableInformation?: any;
  [key: string]: any;
}

@Component({
  selector: 'app-template-detail',
  templateUrl: './template-detail.component.html',
  styleUrls: ['./template-detail.component.scss'],
  standalone: false,
  providers: [
    BuilderScreenBetaService,
    TabControlService,
    SaveComponentsService,
    DataBindingService,
    DataSyncService,
    FormSyncService,
    DataPathService,
    RxTimingService,
    FlowCompletionNotifyService
  ]
})
export class TemplateDetailComponent implements OnInit, OnDestroy {
  @Input() templateId: number;
  @Input() context: TemplateDetailContext = {};
  @Output() saving = new EventEmitter<{ changing: boolean; keepOpen: boolean }>();

  loading = true;
  error = false;
  errorMessage = '';
  private flowCompleteSub?: Subscription;

  constructor(
    private templateApi: TemplateApiService,
    private builderService: BuilderScreenBetaService,
    private flowCompletionNotify: FlowCompletionNotifyService
  ) {}

  ngOnInit(): void {
    if (!this.templateId || this.templateId <= 0) {
      this.error = true;
      this.errorMessage = 'Template ID não fornecido ou inválido';
      this.loading = false;
      return;
    }

    this.flowCompleteSub = this.flowCompletionNotify.onFlowComplete$.subscribe(() => {
      this.saving.emit({ changing: true, keepOpen: false });
    });

    this.templateApi.getTemplateById(this.templateId).subscribe({
      next: (template) => {
        this.builderService.applyTemplate(template);
        this.loading = false;
      },
      error: (err) => {
        console.error('Erro ao carregar template:', err);
        this.error = true;
        this.errorMessage = 'Erro ao carregar template: ' + (err?.message || 'Erro desconhecido');
        this.loading = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.flowCompleteSub?.unsubscribe();
  }

}
